import React, { useCallback, useMemo, useState } from 'react'
import Resx from '@/components/Resx'
import LoadingIndicator from '@/components/LoadingIndicator'
import { Button } from '@/components/button'
import context from '@/context'
import { WhiteBox } from '@/components/Layout/Layout.Box'
import {
  actionButtonsColumnProps,
  BsrsGrid,
  DateCell,
  LookupCell
} from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { dialogTypes } from '@/dialogs'
import { useDialog } from '@/hooks/useDialog'
import { useLocalization } from '@/hooks/localization'
import { dispatchError } from '@/utils/serverErrorHandler'
import { useDispatch } from '@/hooks/dispatch'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'

const createDto = userId => ({ impersonatedUserId: userId, id: 0 })

function Impersonators ({ user }) {
  const userId = user.id
  const openDialog = useDialog()
  const { localize } = useLocalization()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const isGranted = usePermissionChecker()

  const editEntity = useCallback((item) => {
    openDialog({
      dialogType: dialogTypes.impersonation,
      primaryButtonText: 'Common.SaveAndClose',
      onAction: (data) => {
        setLoading(true)
        context.api.impersonationService.save(data)
          .finally(() => setLoading(false))
          .catch(err => dispatchError(dispatch, err))
      },
      item
    })
  }, [dispatch, openDialog])
  const handleDeleteClick = useCallback((item) => {
    setLoading(true)
    context.api.impersonationService.delete(item.id)
      .finally(() => setLoading(false))
      .catch(err => dispatchError(dispatch, err))
  }, [dispatch])

  const dataSource = useCallback((request, options) => {
    if (!request) request = {}
    if (!request.filter) request.filter = { logic: 'and', filters: [] }
    request.filter.filters.push({ field: 'impersonatedUserId', operator: 'eq', value: userId })
    request.sort && request.sort.forEach(x => {
      if (x.field.startsWith('impersonatorUser')) {
        x.field = 'impersonatorUserName'
      }
    })
    return context.api.impersonationService.getTableData(request, options)
  }, [userId])

  const canManage = isGranted('CanManageImpersonations')

  const rowButtons = useMemo(() => {
    let actions = [
      {
        icon: 'pencil',
        onClick: editEntity
      },
      {
        onDelete: handleDeleteClick
      }
    ]

    if (canManage) {
      return actions
    }
  }, [editEntity, handleDeleteClick, canManage])
  // const { user, localize, deleteEntity, openDialog, saving, locale } = this.props

  if (!isGranted(['CanViewImpersonations', 'CanManageImpersonations'])) {
    return null
  }

  return (
    <WhiteBox header='UsersManagement.Impersonators'>
      {canManage &&
      <Button color='primary' className='btn-sm' disabled={loading} onClick={() => editEntity(createDto(userId))} icon='plus'>
        <Resx name='Common.Add' />
      </Button>}
      {loading ? <LoadingIndicator />
        : <BsrsGrid
          simpleView
          dataSource={dataSource}>
          <Column field='impersonatorUser' title={localize('UsersManagement.ImpersonatorUser')} cell={LookupCell} width='300px' />
          <Column field='validFrom' title={localize('Common.ValidFrom')} cell={DateCell} width='150px' />
          <Column field='validTo' title={localize('Common.ValidTo')} cell={DateCell} width='150px' />
          <Column {...actionButtonsColumnProps(rowButtons)} />
        </BsrsGrid>}
    </WhiteBox>
  )
}

export default Impersonators



// WEBPACK FOOTER //
// ./src/internal-app/pages/usersManagement/impersonators.js